import { useTooltip } from './hooks';
/**
 * Display tooltip by mouseover.
 */
export function Tooltip(props) {
    return useTooltip(props);
}
//# sourceMappingURL=Tooltip.js.map